module.exports = __webpack_public_path__ + "img/zalo.0fab55a.svg";